<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-02-29 16:16:35
 * @LastEditors: hexy
 * @LastEditTime: 2024-04-12 16:03:56
 * @Description: 配合比下发
 * @FilePath: \ICPSxin\src\views\platform\ICPS\basicConfig\mixIssue.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div>
          <div style="display:flex">
            <div class="tabtop" style="width: 380px">
              <div v-for="(item, index) in mixTypeList" :key="index" @click="choose(item.status)">
                <div :class="currenIndex == item.status ? 'active' : 'text'">{{ item.value }}</div>
              </div>
            </div>
            <div style="margin-top:16px ;font-size: 16px;display:flex;align-items: center;">
              <span style="margin-left: 24px">
                  <span style="margin-right: 12px">站点名称</span>
                  <el-select ref="selection" v-model="tableParam.stationId" style="width: 150px" filterable @change="getPointDetails">
                    <el-option v-for="item in stationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">订单号</span>
                <el-input v-model="tableParam.orderNo" style="width: 100px" placeholder="请输入" clearable />
              </span>

              <span style="margin-left: 24px">
                <span style="margin-right: 12px">浇筑时间</span>
                <el-date-picker v-model="startTimDateEndTimDate" unlink-panels value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange" :default-time="['00:00:00', '23:59:59']" start-placeholder="开始时间"
                  end-placeholder="结束时间" style="width: 340px"
                  @change="(tableParam.startQueryTime = startTimDateEndTimDate ? startTimDateEndTimDate[0] : ''), (tableParam.endQueryTime = startTimDateEndTimDate ? startTimDateEndTimDate[1] : '')"></el-date-picker>
              </span>
              <span v-if="currenIndex == 2" style="margin-left: 24px">
                  <span style="margin-right: 12px">状态</span>
                  <el-select ref="selection" v-model="tableParam.logStatus" style="width: 100px" filterable>
                    <el-option :key="2" label="已开具" value="2"></el-option>
                    <el-option :key="3" label="在产" value="3"></el-option>
                    <el-option :key="4" label="完成" value="4"></el-option>
                  </el-select>
                </span>
            </div>
          </div>
          <el-collapse-transition>
            <div>
              <div class="search" style="font-size: 16px">
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">工程名称</span>
                  <el-input v-model="tableParam.engineeringName" style="width: 150px" placeholder="请输入" clearable />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">浇筑部位</span>
                  <el-input v-model="tableParam.structuralParts" style="width: 150px" placeholder="请输入" clearable />
                </span>
                <span style="margin-left: 24px">
                  <span style="margin-right: 12px">产品名称</span>
                  <el-input v-model="tableParam.productName" style="width: 100px" placeholder="请输入" clearable />
                </span>
                <span v-if="currenIndex == 2" style="margin-left: 24px">
                  <span style="margin-right: 12px">生产线</span>
                  <el-input v-model="filterLine" style="width: 100px" placeholder="请输入" clearable />
                </span>
                

                <el-button icon="el-icon-search" size="medium" class="bottom_all"
                  @click="(tableParam.page = 1), initData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div class="card_info" :style="{ height: screenHeight - 400 }">
              <el-table v-if="currenIndex == 1" key="table1" ref="table1" v-loading="loading" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-cell-style="{ background: '#f3f6f9' }"
                :cell-style="{ borderRight: 'none' }" border stripe :height="screenHeight - 400" style="width: 100%"
                :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
                <template v-for="(item, index2) in table1">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                    :min-width="item.width" :fixed="item.fixed" :prop="item.prop" :sortable="item.sortable">
                    <template slot-scope="scope">
                      <div v-if="item.label == '操作'">
                        <el-link :underline="false" type="warning"
                          @click="AddMixRatioInfo(scope.row, true)">开具配合比</el-link>
                        <!-- <el-button v-if="scope.row.status != 9 && ButtonList.findIndex(res => res.buttonValue == 'ZUOFEI') !== -1" size="mini" style="margin: 5px 5px" class="bottom_one" @click="cancelFun(scope.row)">启用</el-button> -->
                      </div>
                      <span v-else>{{ scope.row[item.prop] || "-" }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
              <el-table v-else ref="table2" key="table2" v-loading="loading" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-cell-style="{ background: '#f3f6f9' }"
                :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :height="screenHeight - 400"
                :data="filteredData" tooltip-effect="dark" @selection-change="handleSelectionChange">
                <template v-for="(item, index2) in table2">
                  <el-table-column v-if="item.label == '历史变更' ? ButtonList.findIndex(res=>(res.buttonValue=='LSBG'))!==-1 : item.status" :key="index2" :label="item.label" align="center" :width="item.width"
                    :fixed="item.fixed" :prop="item.prop" :sortable="item.sortable">
                    <template slot-scope="scope">
                      <div v-if="item.label == '产品名称'">
                        <span style="color: yellowgreen" @click="lookRatioDetail(scope.row)">{{ scope.row.productName
                        }}</span>
                      </div>
                      <div v-else-if="item.label == '状态'">
                        <span v-if="scope.row.mixProportionStatus == 1">未开具 </span>
                        <span v-if="scope.row.mixProportionStatus == 2">已开具 </span>
                        <span v-if="scope.row.mixProportionStatus == 3">在产 </span>
                        <span v-if="scope.row.mixProportionStatus == 4">完成 </span>
                      </div>
                      <div v-else-if="item.label == '历史变更'">
                        <el-link :underline="false" type="warning" style="margin-left: 5px"
                          @click="checkHistory(scope.row)">查看详情</el-link>
                      </div>
                      <div v-else-if="item.label == '操作'">
                        <el-link :underline="false" type="warning" @click="AddMixRatioInfo(scope.row, false)">修改</el-link>
                        <!-- <el-link :underline="false" type="warning" style="margin-left: 5px;" @click="checkHistory(scope.row)">历史修改</el-link> -->
                        <!-- <el-button v-if="scope.row.status != 9 && ButtonList.findIndex(res => res.buttonValue == 'ZUOFEI') !== -1" size="mini" style="margin: 5px 5px" class="bottom_one" @click="cancelFun(scope.row)">启用</el-button> -->
                      </div>
                      <span v-else>{{ scope.row[item.prop] || "-" }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange"
            @current-change="initData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="initData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 开具配合比 -->
    <mixRatio ref="addMixRatio" :mixRatioDialog.sync="ratioDialog" :isSaveType.sync="isSave" :mixData.sync="mixData"
      :isMixOut.sync="isMixOut" @selectRatioDetail="initData()" />
    <!-- 历史记录 -->
    <ratioHistory ref="historyRatio" :isHistoryDialog.sync="ratioHistoryDialog" :config="mixRow"
      @selectHistoryDetail="selectHistoryDetail" />
    <!-- 查看配合比 -->
    <lookRatio ref="lookRatio" :isLookRatioDialog.sync="lookDialog" :Item="row" />
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { qualityMixProportionPage } from "@/api/basicConfig/mixIssue.js";
import lookRatio from "./components/lookRatio.vue";
import ratioHistory from "./components/ratioHistory.vue";
import mixRatio from "./components/mixRatio.vue";
import { getUserAutList } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth";
import {
  queryProcesses,
} from "@/api/basicConfig/proflow.js";
export default {
  components: {
    mixRatio,
    ratioHistory,
    lookRatio,
  },
  mixins: [mixin],
  data() {
    return {
      /*表格增删改查及下载接口*/
      /*表格数据*/
      loading: true,
      UserInfo: "",
      startTimDateEndTimDate: [],
      pagesType: 0,
      fromDate: {
        code: "",
      },
      currenIndex: 1,
      mixTypeList: [
        {
          value: "待开具",
          status: 1,
        },
        {
          value: "已开具",
          status: 2,
        },
      ],
      total: 0,
      selectRow: [],
      /*表格数据*/
      table1: [
        { label: "订单号", width: "140", prop: "orderNo", status: true, sortable: false },
        { label: "工程项目", width: "280", prop: "engineeringName", status: true, sortable: false },
        { label: "浇筑部位", width: "100", prop: "structuralParts", status: true, sortable: false },
        { label: "产品名称", width: "200", prop: "productName", status: true, sortable: false },
        { label: "站点名称", width: "150", prop: "stationName", status: true, sortable: false },
        { label: "浇筑方式", width: "200", prop: "pouringMethodSplit", status: true, sortable: false },
        { label: "计划用量 ", width: "100", prop: "pouringNum", status: true, sortable: false },
        { label: "浇筑时间", width: "200", prop: "pouringTime", status: true, sortable: false },
        { label: "操作", width: "160", prop: "", status: true, sortable: false, fixed: "right" },
      ],
      table2: [
        { label: "状态", width: "70", prop: "mixProportionStatus", status: true, sortable: false },
        { label: "订单号", width: "140", prop: "orderNo", status: true, sortable: false },
        { label: "站点", width: "70", prop: "stationName", status: true, sortable: false },
        { label: "工程项目", width: "auto", prop: "engineeringName", status: true, sortable: false },
        { label: "浇筑部位", width: "150", prop: "structuralParts", status: true, sortable: false },
        { label: "浇筑方式", width: "140", prop: "pouringMethodSplit", status: true, sortable: false },
        { label: "浇筑时间", width: "140", prop: "pouringTime", status: true, sortable: false },
        { label: "产品名称", width: "140", prop: "productName", status: true, sortable: false },
        // { label: "配合比名称", width: "180", prop: "mixName", status: true, sortable: false },
        { label: "生产线", width: "120", prop: "lineNames", status: true, sortable: false },
        { label: "计划用量 ", width: "70", prop: "pouringNum", status: true, sortable: false },
        { label: "累计车次", width: "70", prop: "logisticsCarNum", status: true, sortable: false },
        { label: "累计方量", width: "80", prop: "logisticsCarFaceValue", status: true, sortable: false },
        { label: "历史变更", width: "100", prop: "", status: true, sortable: false },
        { label: "操作", width: "70", prop: "", status: true, sortable: false },
      ],
      // 开具配合比
      isSave: false,
      ratioDialog: false,
      ratioHistoryDialog: false,
      lookDialog: false,
      mixData: {}, //当前行数据
      row: {},
      mixRow: {},
      stationList: [],
      isMixOut: false,
      filterLine: "",
    };
  },
  computed: {
    filteredData() {
      if (this.filterLine) {
        console.log('11111111111111')
        return this.tableData.filter(item => item.lineNames && item.lineNames.includes(this.filterLine));
      } else {
        return this.tableData;
      }
    }
  },
  async created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.UserInfo = await getUserInfo();
    this.getTime();

    console.log(this.startTimDateEndTimDate);
    console.log(this.tableParam);
    this.stationList = await getUserAutList(true);
    this.tableParam = { ...this.tableParam, productName: "", stationId: "", engineeringName: "", structuralParts: "", orderNo: "", mixProportionStatus: 1, logStatus: "", };
    this.tableParam.pageSize = 200
    if (this.UserInfo.pointIds.length > 0) {
      this.tableParam.stationId = this.UserInfo.pointIds[0];
    } else {
      this.tableParam.stationId = this.stationList[0].id;
    }
    this.getPointDetails();
    this.initData();
  },
  watch: {
    startTimDateEndTimDate(val) {
      if (val?.length > 0) {
        this.tableParam.startQueryTime = val[0];
        this.tableParam.endQueryTime = val[1];
      } else {
        this.tableParam.startQueryTime = "";
        this.tableParam.endQueryTime = "";
      }
    },
  },
  methods: {
    //获取站点工艺流程
    getPointDetails() {
      let _this = this
      this.isMixOut = false
      queryProcesses({ stationId: this.tableParam.stationId }).then(res => {
        if (res.code === 1001) {
          const newData = JSON.parse(res.data.servicePoint).map(item => item.name);
          if (newData.findIndex(item => item == '工控对外配合比') !== -1) {
            _this.isMixOut = true
          }
        }
      });
    },
    handleSelectionChange(row) {
      this.selectRow = row;
    },
    getNextDay(date) {
      const nextDate = new Date(date);
      nextDate.setDate(date.getDate() + 1);
      return nextDate.toISOString().split("T")[0];
    },
    getYesterdayDate(date) {
      const yesterday = new Date(date);
      yesterday.setDate(yesterday.getDate() - 1);
      return yesterday.toISOString().split("T")[0];
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    getTime() {
      this.startTimDateEndTimDate = [];
      this.startTimDateEndTimDate[0] = this.getYesterdayDate(new Date()) + " 00:00:00";
      this.startTimDateEndTimDate[1] = this.getNextDay(new Date()) + " 23:59:59";
      this.tableParam.startQueryTime = this.startTimDateEndTimDate[0];
      this.tableParam.endQueryTime = this.startTimDateEndTimDate[1];
    },
    init() {
      this.getTime();
      this.tableParam.productName = "";
      this.tableParam.engineeringName = "";
      this.tableParam.structuralParts = "";
      this.tableParam.orderNo = "";
      this.tableParam.logStatus = "";
      this.tableParam.filterLine = "";
      if (this.UserInfo.pointIds.length > 0) {
        this.tableParam.stationId = this.UserInfo.pointIds[0];
      } else {
        this.tableParam.stationId = this.stationList[0].id;
      }
      this.tableParam.page = 1
      this.filterLine = ""
      // this.tableParam.mixProportionStatus = 1;
      this.initData();
    },
    choose(num) {
      this.currenIndex = num;
      this.tableParam.mixProportionStatus = num;
      this.tableParam.logStatus = '';
      this.initData();
      if (this.currenIndex == 1) {
        this.$refs.table1.doLayout();
      } else {
        this.$refs.table2.doLayout();
      }
    },
    initData() {
      // this.getTime()
      this.loading = true;
      qualityMixProportionPage({ ...this.tableParam }).then(res => {
        if (res.code === 1001) {
          this.tableData = res.data.data;
          this.total = res.data.totalRows;
        }
        this.loading = false;
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.initData();
    },
    AddMixRatioInfo(row, type) {
      if(row.approvalStatus == 4 && this.currenIndex == 1) {
        this.$message.warning('已取消订单不能开具配合比!')
        return
      }
      this.mixData = row;
      this.ratioDialog = true;
      this.isSave = type;
      console.log(type);
      this.$refs.addMixRatio.addClick(row);
    },
    lookRatioDetail(row) {
      this.row = row;
      this.lookDialog = true;
    },
    checkHistory(row) {
      this.mixRow = row;
      this.ratioHistoryDialog = true;
    },
    selectRatioDetail() { },
    selectHistoryDetail() { },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
